import {
  AfterViewInit,
  Component,
  ComponentRef, EventEmitter,
  Injector, Input,
  OnDestroy,
  OnInit, Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {NgxFilterBase} from "../../ngx-filter-base";
import {Filter} from "../../../ngx-types";

@Component({
  selector: 'ngx-text-filter',
  templateUrl: '../../ngx-filter-single-template-base.html',
})
export class NgxTextFilterComponent extends NgxFilterBase implements OnInit, OnDestroy, AfterViewInit {

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  @Input() filter: Filter;
  @Output() changeValue = new EventEmitter<any>();

  get Label1(): string {
    return this.filter?.label;
  }

  get Label2(): string {
    return '';
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    this.generateComponents(this.filterService.filtersComponent.textBox, null);
  }
}
